module.exports = __webpack_public_path__ + "static/media/70 - Wham - Everything She Wants.a55612a5.mp3";